import request from '../helpers/request';
import { customer } from './apiMapping';

/**
 * Get user's address using zipcode
 *
 * @param {string} zipcode
 * @returns {Promise}
 */
const getAddressByZipcode = (zipcode) => request(customer.getAddressByZipcode, {zipcode});

/**
 * Check if user exists
 *
 * @param {string} email
 * @returns {Promise}
 */
const getUserExistence = (email) => request(customer.getUserExistence, {email});

/**
 * Log user in and get his data
 * 
 * @param {string} email
 * @param {string} password
 * @returns {Promise}
 */
const getUserData = (email, password) => request(customer.getUserData, {email, password}, {method: 'post'});

/**
 * Log user data into RD Station
 * 
 * @param {Object} userPayload
 * @returns {Promise}
 */
const postLeadData = (userPayload) => request(customer.postLeadData, userPayload, {method: 'post'});


export { getAddressByZipcode, getUserExistence, getUserData, postLeadData };